import Typography from "@mui/material/Typography";
import React from "react";
import { TicketErrorHelper } from "../../../Utils/TicketErrorHelper";
import { MenuCardContent, ValidationResult } from "../../../Utils/Interfaces";
import { optionalEss } from "../../../Utils/UtilityMethods";
import { TicketExtended } from "../../../Utils/TypeExtensions";

export default function PassengerMenuContent(ticket: TicketExtended, title: string, validationResults: ValidationResult[]): MenuCardContent {
    const details = (
        <Typography textAlign={"center"}>
            {ticket?.Pax?.length ?? 0} PASSENGER{optionalEss(ticket?.Pax?.length ?? 0)}
        </Typography>
    );
    const validationMessages = TicketErrorHelper.getCardErrors(validationResults, title);

    return { details, validationMessages };
}
